<template>
  <ul v-if="props.items">
    <template v-for="(item,i) of props.items">
      <li v-if="isVisible(item) && !item.separator" :key="item.label ?? i" :class="[{'layout-root-menuitem': props.root, 'active-menuitem': activeIndex === i && !item.disabled}]">
        <div v-if="props.root && item.items.filter((subItem) => subItem.isActivated).length"><span class="layout-menuitem-text">{{item.label}}</span></div>
        <router-link v-if="item.to && item.isActivated" :to="{ path: item.to, query: item.query }" :style="item.style" :class="[item.class, 'p-ripple', {'p-disabled': item.disabled}]" :target="item.target" active-class="active-route" exact @mouseenter="onMenuItemMouseEnter(i)" @mouseleave="onMenuItemMouseLeave" @click="onMenuItemClick($event,item,i)" v-ripple>
          <i :class="['layout-menuitem-icon', 'material-symbols-outlined', item.icon]"></i>
          <span class="layout-menuitem-text">{{item.label}}</span>
          <span class="p-badge p-component p-badge-no-gutter" :class="item.badgeStyleClass" v-if="item.badge && !props.root">{{item.badge}}</span>
          <i v-if="item.items" class="material-symbols-outlined expand_less layout-submenu-toggler"></i>
        </router-link>
        <a v-if="!item.to  && item.items.filter((subItem) => subItem.isActivated).length" :href="item.url ?? '#'" :style="item.style" :class="[item.class, 'p-ripple', {'p-disabled': item.disabled}]" :target="item.target" @click="onMenuItemClick($event,item,i)" @mouseenter="onMenuItemMouseEnter(i)" @mouseleave="onMenuItemMouseLeave" v-ripple>
          <i :class="['layout-menuitem-icon', 'material-symbols-outlined', item.icon]"></i>
          <span class="layout-menuitem-text">{{item.label}}</span>
          <span class="p-badge p-component p-badge-no-gutter" :class="item.badgeStyleClass" v-if="item.badge && !props.root">{{item.badge}}</span>
          <i v-if="item.items" class="material-symbols-outlined expand_more layout-submenu-toggler"></i>
        </a>
        <span class="layout-menuitem-tooltip p-tooltip">
          <span class="layout-menuitem-tooltip-arrow p-tooltip-arrow"></span>
          <span class="layout-menuitem-tooltip-text p-tooltip-text">{{item.label}}</span>
        </span>
        <transition name="layout-menu">
          <AppSubMenu v-show="item.items && (props.root && (!isSlim() || (isSlim() && (props.mobileMenuActive || activeIndex !== null))) ? true : activeIndex === i)" :items="isVisible(item) && item.items" @menuitem-click="$emit('menuitem-click', $event)" :menuActive="props.menuActive" :parentMenuItemActive="activeIndex === i" />
        </transition>
      </li>
      <li class="p-menu-separator" :style="item.style" v-if="isVisible(item) && item.separator" :key="'separator' + i.toString()"></li>
    </template>
	</ul>
</template>

<script setup>
  import { inject, ref, onMounted } from "vue";
  import AppSubMenu from "@/views/_app/AppSubMenu.vue";
  import EventBus from "@/utilities/eventBus.js";
  const appState = inject("appState");
  const emit = defineEmits([ "menuitem-click", "root-menuitem-click" ]);
  const props = defineProps({
		items: Array,
		root: {
			type: Boolean,
			default: false
		},
		menuActive: {
			type: Boolean,
			default: true
		},
		parentMenuItemActive: {
			type: Boolean,
			default: false
		},
		mobileMenuActive: Boolean,
		isSlimOrHorizontalItemClick: Boolean
  });
  const activeIndex = ref(null);
	const hoverMenuActive = ref(false);
	const isSlim = () => appState.user.preferences.appMenuMode === "slim";
  const isHorizontalOrSlim = () => (appState.user.preferences.appMenuMode === "horizontal" || appState.user.preferences.appMenuMode === "slim");
  const isMobile = () => window.innerWidth <= 991;
	function onMenuItemClick(event, item, index) {
    if (item.disabled) {
      event.preventDefault();
      return;
    }
    if (item.command) {
      event.preventDefault();
      item.command({ originalEvent: event, item: item });
    }
    if (item.items) {
      event.preventDefault();
    } else {
      if(isHorizontalOrSlim()) hoverMenuActive.value = false;
      if(appState.user.preferences.appMenuMode !== "static") {
        const ink = getInk(event.currentTarget);
        if(ink) removeClass(ink, "p-ink-active");
      }
    }
    if (props.root) {
      hoverMenuActive.value = !hoverMenuActive.value;
      emit("root-menuitem-click", { originalEvent: event, isSameIndex: index === activeIndex.value });
    }
    if (item.items) activeIndex.value = index === activeIndex.value ? null : index;
    emit("menuitem-click", { originalEvent: event, item: item });
  }
	function onMenuItemMouseEnter(index) {
    if(props.isSlimOrHorizontalItemClick) hoverMenuActive.value = true;
    if(props.root && hoverMenuActive.value && isHorizontalOrSlim() && !isMobile()) activeIndex.value = index;
  }
	function onMenuItemMouseLeave() {
    hoverMenuActive.value = false;
  }
  function isVisible(item) {
    return (typeof item.visible === "function" ? item.visible() : item.visible !== false);
  }
	function getInk(el) {
    for (let child of el.children) {
      if (typeof child.className === "string" && child.className.indexOf("p-ink") !== -1) return child;
    }
    return null;
  }
	function removeClass(element, className) {
    if (element.classList) { 
      element.classList.remove(className);
    } else {
      element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  }
  onMounted(() => {
		EventBus.on("reset-active-index", () => {
			if(isHorizontalOrSlim() && !isMobile()) {
				activeIndex.value = null;
			}
		});
  });
</script>